import { Link } from 'react-router';
import { Icon } from '@/comp/icon/icon';
import { affiliate_checkIsAllowToBookService, checkTripEnded } from '@/_helper/checkAccess';
import InfoCard from '@/comp/ui/infoCard/infoCard';
import TravelTile from '@/comp/travelTile';
import { AppContext } from '@/context/AppContext';
import { useContext } from 'react';

export const ClaimOption = () => {
    const service = 'claim';
    const { bookingData } = useContext(AppContext);

    if (!bookingData || (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service))) {
        return false;
    }

    return (
        <div className="tab-content-container">
            {window.$browserInfo.device === 'mobile' && <div className="modal-mobile-background-layer"></div>}
            <div className="tab-header">
                <h3>Reklamation</h3>
                {window.$browserInfo.device === 'mobile' && (
                    <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                        <Icon name="close" ariaLabel="overlay schließen" />
                    </Link>
                )}
            </div>
            <div className="tab-content">
                {!checkTripEnded() ? (
                    <InfoCard type="large">
                        <div>
                            <p>Sie können eine Reklamation erst nach Reiseende hier einreichen.</p>
                            <p>
                                <b>
                                    Es ist wichtig, auftretende Mängel sofort während der Reise bei AurumTours zu
                                    melden.
                                </b>{' '}
                                Nur so können wir Ihnen schnell und direkt helfen. Für nachträglich angezeigte Mängel
                                besteht kein Entschädigungsanspruch. Bitte bewahren Sie alle Zahlungsbelege, Quittungen
                                etc. sorgfältig auf.
                            </p>
                            <p>
                                Bei Problemen oder Fragen nutzen Sie bitte das{' '}
                                <a
                                    rel="noopener noreferrer"
                                    href={`${window.$website}/service/kontakt`}
                                    target="_blank">
                                    Kontaktformular
                                </a>
                                .
                            </p>
                        </div>
                    </InfoCard>
                ) : (
                    <TravelTile
                        name="claim"
                        icon="syncProblem"
                        headline="Reklamation"
                        description={
                            window.$claimEnabled !== 'false' && bookingData.data?.allowClaim
                                ? 'Mit Ihrer Reise war etwas nicht in Ordnung? Reichen Sie Ihre Reklamation ganz einfach hier ein.'
                                : 'Sie haben bereits eine Reklamation zu Ihrer Reise eingereicht.'
                        }
                        state={
                            window.$claimEnabled !== 'false' && bookingData.data?.allowClaim
                                ? 'show'
                                : 'is-already-booked'
                        }
                        link="reklamation"
                        linkType="internal"
                        target="_blank"
                    />
                )}
            </div>
        </div>
    );
};
